
















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class HorizontalIcon extends Vue {
  @Prop({ default: '21' }) readonly width?: string;
  @Prop({ default: '13' }) readonly height?: string;
  @Prop({ default: 'currentColor' }) readonly color?: string;
}
